import { useState } from 'react';
import {
    Box,
    Typography,
    Grid,
    TextField,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormGroup, Switch, FormControlLabel
} from '@mui/material';
import stateOptions from "../shared/stateOptions.js";
import VenueCard from "./VenueCard.jsx"


// Main VenueList component
const VenueList = (props) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [locationFilter, setLocationFilter] = useState('');
    const [minorsOkFilter, setMinorsOkFilter] = useState(false)
    const [freeFilter, setFreeFilter] = useState(false)

    // Filter venues based on search and state filter
    const filteredVenues = props.venues.filter(venue => {
        const matchesSearch = venue.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (venue.city && venue.city.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (typeof venue.whatToExpect === "string" && venue.whatToExpect.toLowerCase().includes(searchTerm.toLowerCase()))
        const matchesState = locationFilter ? venue.state === locationFilter : true;
        const matchesAllAges = minorsOkFilter ? ['all-ages', 'minor-with-guardian'].includes(venue.age) : true;
        const matchesFree = freeFilter ? venue.cover &&venue.cover.toLowerCase().indexOf("free") !== -1 : true;

        return matchesSearch && matchesState && matchesAllAges && matchesFree;
    });

    return (

            <Box sx={{ mb: 4, mt: 2 }}>
                {/* Filters */}
                <Grid container spacing={1}>
                    <Grid item xs={12} md={6}>
                        <Box mb={2}>
                            <TextField
                                fullWidth
                                label="Search venues"
                                variant="outlined"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                />
                        </Box>
                    </Grid>

                    {props.showStateFilter && <Grid item xs={12} md={6}>
                        <FormControl fullWidth>
                            <InputLabel>State</InputLabel>
                            <Select
                                value={locationFilter}
                                label="State"
                                onChange={(e) => setLocationFilter(e.target.value)}>
                                <MenuItem value="">
                                    <em>All States</em>
                                </MenuItem>
                                {stateOptions.map(state => (
                                    <MenuItem key={state.key} value={state.key}>{state.name}</MenuItem>
                                 ))}
                            </Select>
                        </FormControl>
                    </Grid>}

                    <Grid item xs={12} md={6}>
                        <Box style={{display: "flex", justifyContent: "space-evenly"}} mb={2} >
                            <FormGroup>
                                <FormControlLabel control={<Switch checked={minorsOkFilter} onChange={e => setMinorsOkFilter(e.target.checked)}/>} label="Minors OK" />
                            </FormGroup>

                            <FormGroup>
                                <FormControlLabel control={<Switch checked={freeFilter} onChange={e => setFreeFilter(e.target.checked)}/>} label="Free Only" />
                            </FormGroup>
                        </Box>
                    </Grid>

            </Grid>

            {/* Venue Cards */}
            <Grid container spacing={3}>
                {filteredVenues.length > 0 ? (
                    filteredVenues.map((venue) => (
                        <Grid item key={venue.venueKey} xs={12} sm={6} md={4}>
                            <VenueCard venue={venue} showCityState={props.showCityState} />
                        </Grid>
                    ))
                ) : (
                    <Grid item xs={12} key={0}>
                        <Typography variant="body1" color="text.secondary" align="center">
                            No venues found matching your criteria.
                        </Typography>
                    </Grid>
                )}
            </Grid>
        </Box>
    );
};

export default VenueList;